import { createContext, useContext } from 'react'
import { useUpsellStripeCheckout } from './useUpsellStripeCheckout'

const UpsellCheckoutContext = createContext(null)

export function UpsellCheckoutProvider({ children }) {
  const checkout = useUpsellStripeCheckout()

  return (
    <UpsellCheckoutContext.Provider value={checkout}>
      {children}
      {checkout.stripeCheckoutModal}
    </UpsellCheckoutContext.Provider>
  )
}

export function useUpsellCheckout() {
  const context = useContext(UpsellCheckoutContext)

  if (!context) {
    throw new Error('useUpsellCheckout must be used within UpsellCheckoutProvider')
  }

  return context
}
